import { PageMeta } from '@components/page-meta';
import PageContainer from '@components/PageContainer';
import { RouteComponentProps } from '@reach/router';
import ConfigurationCostsForm from 'src/containers/ConfigurationCostsForm';

const CostsPage = (_props: RouteComponentProps) => (
  <>
    <PageMeta title="configuration.costConfig" />
    <PageContainer>
      <ConfigurationCostsForm />
    </PageContainer>
  </>
);

export default CostsPage;
